import React from 'react';
import {
  composeAbbrev,
} from '../../../util/util.jsx';

export default class SimpleNameDisplayWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dataToDisplay: '' };
  }

  componentWillMount() {
    if (!this.props.itemList || this.props.itemList.size == 0) {
      this.loadData();
    }
    if (this.props.itemList && this.props.itemList.size > 0) {
      this.setState({ dataToDisplay: this.getDataToDisplay(this.props) });
    }
  }

  componentWillReceiveProps(props) {
    if (!props.itemList || props.itemList.size == 0) {
      this.loadData();
    }
    if (props.itemList
        && (props.itemList != this.props.itemList
        || props.id != this.props.id)) {
      this.setState({ dataToDisplay: this.getDataToDisplay(props) });
    }
  }


  shouldComponentUpdate(nextProps) {
    if (nextProps.itemList
        && (nextProps.itemList != this.props.itemList
        || nextProps.id != this.props.id)) {
      return true;
    }
    return false;
  }

  getDataToDisplay(props) {
    let dataToDisplay = '';
    if (props.itemList) {
      const item = props.itemList
        .find(ref => (ref.get ? ref.get('id') == props.id : ref.id == props.id));
      if (item) {
        const name = item.get ? item.get('name') : '';
        if (props.asRegNumberPrefix) {
          dataToDisplay = composeAbbrev(name);
        } else {
          dataToDisplay = name;
        }
      }
    }
    if (props.upperCase) {
      return dataToDisplay.toUpperCase();
    }
    return dataToDisplay;
  }
  loadData() { }
  render() {
    const propsStyle = this.props.style || {};
    const borderStyle = !this.props.noBorder && this.props.color
     && this.state.dataToDisplay ? {
        ...propsStyle,
        border: 'thin solid rgba(150, 150, 150, 0.4)',
        borderRadius: '5px',
        padding: '2px',
        marginBottom: '1px',
        background: `${this.props.color}`,
      } : { ...propsStyle };

    return (
      <div style={this.props.baseStyle ? this.props.baseStyle : { display: 'inline' }}>
        {this.props.prefix || ''}
        <span
          style={{ ...borderStyle, display: this.props.prefix ? 'inline' : 'inline-block' }}
          className={this.props.className || ''}
        >
          <span style={{ display: 'inline', wordBreak: 'break-all', whiteSpace: 'normal' }}>
            {this.state.dataToDisplay}
          </span>
        </span>
      </div>
    );
  }
}
SimpleNameDisplayWrapper.propTypes = {
  itemList: React.PropTypes.object,
  id: React.PropTypes.oneOfType(
    [React.PropTypes.number,
      React.PropTypes.string,
    ]),
  asRegNumberPrefix: React.PropTypes.bool,
  refName: React.PropTypes.string,
  refPath: React.PropTypes.string,
  color: React.PropTypes.string,
  className: React.PropTypes.string,
  prefix: React.PropTypes.oneOfType(
    [React.PropTypes.string,
      React.PropTypes.object,
    ]),
  style: React.PropTypes.object,
  baseStyle: React.PropTypes.object,
  noBorder: React.PropTypes.bool,
};
